<div class="schedule-navbar">
    <div>
        <button (click)="prev()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-left"></mat-icon>
        </button>
    </div>
    <div class="content">
        <p class="large">
            @for (realisation of realisations; track realisation; let last = $last) {
                {{
                    realisation.planning?.afas_project_id ??
                        realisation.project?.afas_project_id ??
                        realisation.afas_project_id
                }}
                {{ last ? '' : ' / ' }}
            }
            @for (realisation of notWorkRealisations; track realisation; let last = $last) {
                {{ realisation.hourtype | hourtype }} {{ last ? '' : ' / ' }}
            }
            @if (!realisations?.length && !notWorkRealisations?.length) {
                niet ingepland
            }
        </p>
        <p class="small">{{ date | date: 'EEEE d MMMM yyyy' }}</p>
    </div>
    <div>
        <button [disabled]="nextDate >= maxDate" (click)="next()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-right"></mat-icon>
        </button>
    </div>
</div>
<div class="content details">
    @if (!realisations?.length && !notWorkRealisations?.length) {
        <div class="head section bg-white">
            <div class="container-xl">
                <h1>
                    {{ date > maxDate ? 'nog niet beschikbaar' : 'niet ingepland' }}
                </h1>
                <div class="data">
                    <div class="data-row">
                        <div class="data-cell">Datum</div>
                        <div class="data-cell strong">{{ date | date: 'd MMMM yyyy' }}</div>
                    </div>
                </div>
            </div>
        </div>
    }
    @for (realisation of notWorkRealisations; track realisation; let index = $index) {
        <div
            class="head section bg-white"
            [class.pt-0]="(notWorkRealisations[index - 1]?.hourtype | hourtype) === (realisation.hourtype | hourtype)">
            <div class="container-xl">
                @if ((notWorkRealisations[index - 1]?.hourtype | hourtype) !== (realisation.hourtype | hourtype)) {
                    <h2 class="mb-0">
                        {{ realisation.hourtype | hourtype }}
                    </h2>
                }
                <div class="data">
                    <div class="data-row">
                        <div class="data-cell">Tijd</div>
                        <div class="data-cell strong">
                            {{ realisation.begindate | date: 'EE HH:mm' }} -
                            {{ realisation.enddate | date: 'EE HH:mm' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    @for (realisation of realisations; track realisation) {
        <div class="head section bg-white">
            <div class="container-xl">
                <div class="d-flex flex-wrap gap-3">
                    <div class="realisation-heading__title flex-shrink-1">
                        <h1>
                            Project
                            <strong>{{ realisation | realisationAfasProjectIdPipe }}</strong>
                        </h1>
                        <h2>
                            {{
                                realisation.project?.name ??
                                    realisation.planning?.project?.name ??
                                    realisation?.user_planning?.project?.name
                            }}
                        </h2>
                    </div>
                    <div
                        class="realisation-heading__actions d-grid flex-grow-1 flex-shrink-0 gap-2 align-self-start mw-100">
                        <button
                            class="w-100"
                            (click)="openOrderForm(realisation.planning_id)"
                            mat-raised-button
                            color="primary">
                            Opdrachtformulier
                        </button>
                        @if (realisation.planning?.id && (Features.DayreportsSave | hasFeature)) {
                            <button
                                class="planning-button w-100"
                                [routerLink]="`/dagrapport/${realisation.planning?.id}`"
                                mat-raised-button
                                color="primary">
                                Dagrapport
                            </button>
                        }
                    </div>
                </div>
                <hr />

                <div class="data">
                    <div class="data-row">
                        <div class="data-cell">Datum</div>
                        <div class="data-cell strong">{{ date | date: 'd MMMM yyyy' }}</div>
                    </div>
                    <div class="data-row">
                        <div class="data-cell">Tijd</div>
                        <div class="data-cell strong">
                            {{ realisation.begindate | date: 'HH:mm' }} - {{ realisation.enddate | date: 'HH:mm' }}
                        </div>
                    </div>
                    <div class="data-row">
                        <div class="data-cell">Locatie</div>
                        <div class="data-cell strong">
                            {{
                                realisation?.project?.location ??
                                    realisation?.user_planning?.project?.location ??
                                    realisation?.planning?.location ??
                                    realisation?.planning_has?.location ??
                                    realisation?.planning_has?.project?.location ??
                                    '-'
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        @if (!realisation?.planning?.is_transport) {
            <div class="section bg-light">
                <div class="container-xl">
                    <div class="data">
                        <div class="data-row">
                            <div class="data-cell">Projectleider</div>
                            <div class="data-cell strong">
                                {{
                                    realisation?.planning?.projectmanager_user?.name ??
                                        realisation?.project?.projectmanager?.name ??
                                        realisation?.user_planning?.project?.projectmanager?.name ??
                                        realisation?.planning_has?.project?.projectmanager?.name ??
                                        '-'
                                }}
                            </div>
                        </div>
                        <div class="data-row">
                            <div class="data-cell">{{ environment.executorName }}</div>
                            <div class="data-cell strong">
                                {{
                                    realisation?.planning?.performer_user?.name ??
                                        realisation?.project?.performer?.name ??
                                        realisation?.user_planning?.project?.performer?.name ??
                                        realisation?.planning_has?.performer?.name ??
                                        '-'
                                }}
                            </div>
                        </div>
                        @if (
                            realisation?.planning?.asphalt_performer_user?.name ||
                            realisation?.project?.asphalt_performer?.name ||
                            realisation?.user_planning?.project?.asphalt_performer?.name
                        ) {
                            <div class="data-row">
                                <div class="data-cell">Asfaltuitvoerder</div>
                                <div class="data-cell strong">
                                    {{
                                        realisation?.planning?.asphalt_performer_user?.name ??
                                            realisation?.project?.asphalt_performer?.name ??
                                            realisation?.user_planning?.project?.asphalt_performer?.name ??
                                            '-'
                                    }}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        @if (!realisation?.planning?.is_transport) {
            <div class="section bg-white">
                <div class="container-xl">
                    <h2>Omschrijving project</h2>
                    <div
                        [innerHTML]="
                            realisation?.planning?.description ??
                                realisation?.planning?.comment ??
                                realisation?.planning_has?.comment ??
                                '-' | nl2br
                        "></div>
                </div>
            </div>
        }

        @if (realisation?.planning?.data) {
            <div class="section bg-light">
                <div class="container-xl">
                    <h2>Overige informatie</h2>
                    <div class="data">
                        <div class="data-row">
                            <div class="data-cell">Mallen</div>
                            <div class="data-cell strong">
                                {{ realisation?.planning?.data?.mallen ? 'Ja' : 'Nee' }}
                            </div>
                        </div>
                        <div class="data-row">
                            <div class="data-cell">Opmeten</div>
                            <div class="data-cell strong">
                                {{ realisation?.planning?.data?.opmeten ? 'Ja' : 'Nee' }}
                            </div>
                        </div>
                        <div class="data-row">
                            <div class="data-cell">Uitzetten</div>
                            <div class="data-cell strong">
                                {{ realisation?.planning?.data?.uitzetten ? 'Ja' : 'Nee' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        @if (planningMaterialMap.get(realisation.planning_id)?.length > 0) {
            <div class="section bg-white">
                <div class="container-xl">
                    <table class="materials">
                        <tr>
                            <th>Materiaal</th>
                            <th>Kleur</th>
                            <th>Dikte (mm)</th>
                            <th>Verbruik (kg/m²)</th>
                            <th>Hoeveelheid (kg)</th>
                        </tr>
                        @for (
                            material of planningMaterialMap.get(realisation.planning_id);
                            track material;
                            let odd = $odd
                        ) {
                            <tr [class.odd]="odd">
                                <td>{{ material | materialProperty: 'name' }}</td>
                                <td>{{ material | materialProperty: 'colorName' }}</td>
                                <td>{{ material | materialProperty: 'thickness' }}</td>
                                <td>{{ material | materialProperty: 'consumption' }}</td>
                                <td>{{ material.quantity | number: '0.0-3' }}</td>
                            </tr>
                            @for (rawMaterial of material | nonMainRawMaterials; track rawMaterial.id) {
                                <tr class="sub-row" [class.odd]="odd">
                                    <td class="sub-row__name">
                                        -
                                        {{
                                            rawMaterial | materialProperty: 'typeName' : rawMaterial.material_type?.name
                                        }}
                                    </td>
                                    <td></td>
                                    <td>{{ rawMaterial.certificate_number }}</td>
                                    <td>{{ rawMaterial.thickness }}</td>
                                    <td>{{ rawMaterial.consumption }} {{ rawMaterial.consumption_type?.name }}</td>
                                    <td></td>
                                </tr>
                            }
                        }
                    </table>
                </div>
            </div>
        }

        @if (!realisation?.planning?.is_transport && realisation.planning.planning_files?.length > 0) {
            <div class="section bg-white">
                <div class="container-xl">
                    <h3>Bijlages</h3>

                    <table>
                        <tr>
                            <th class="icon-col"></th>
                            <th>Bestand</th>
                            <th>Toegevoegd op</th>
                        </tr>

                        @if (realisation?.planning?.planning_files) {
                            @for (file of realisation.planning.planning_files; track file; let odd = $odd) {
                                @if (file?.name) {
                                    <tr [class.odd]="odd">
                                        <td class="icon-col">
                                            <a (click)="downloadFile(file)">
                                                <mat-icon fontSet="fa-regular" fontIcon="fa-file-arrow-down"></mat-icon>
                                            </a>
                                        </td>
                                        <td>
                                            <a (click)="openFile(file)">
                                                {{ file.name }}
                                            </a>
                                        </td>
                                        <td class="time">
                                            {{ file.created_at | date: 'EEEE d MMM yyyy HH:mm' }}
                                        </td>
                                    </tr>
                                }
                            }
                        }
                    </table>
                </div>
            </div>
        }

        @if (realisation.planning_has?.transport_destination) {
            <div class="section bg-light">
                <div class="container-xl">
                    <h2>Locatie transport</h2>
                    @if (realisation.planning_has.transport_origin !== 'none') {
                        Start:
                        {{ realisation.planning_has.transport_origin ?? '-' | replaceIf: 'next' : 'Zie vorige regel'
                        }}<br />
                    }
                    @if (realisation.planning_has.transport_worksite?.length > 0) {
                        <span> Werk: {{ realisation.planning_has.transport_worksite ?? '-' }}<br /> </span>
                    }
                    @if (realisation.planning_has.transport_destination !== 'none') {
                        Einde:
                        {{
                            realisation.planning_has.transport_destination ?? '-'
                                | replaceIf: 'next' : 'Zie volgende regel'
                        }}
                    }
                </div>
            </div>
        }
        @if (realisation?.planning_has?.comment?.length > 0) {
            <div class="section bg-white">
                <div class="container-xl">
                    <h2>Omschrijving transportbeweging</h2>
                    <h3>{{ realisation.planning_has.entity?.name }}</h3>
                    <div>{{ realisation.planning_has.comment }}</div>
                </div>
            </div>
        }

        @if (realisation?.planning?.planning_has_all.length > 0 || realisation?.planning?.user_planning.length > 0) {
            <div class="section bg-light">
                <div class="container-xl">
                    <h2>Met wie werk ik?</h2>
                    @if (!showWorkWith) {
                        <p>Zichtbaar vanaf {{ showWorkWithFrom | date: 'EEEE d MMMM yyyy' }}</p>
                    } @else {
                        <table>
                            <tr>
                                <th>Naam <span class="d-sm-none"> & materieel</span></th>
                                <th class="d-none d-sm-block">Materieel</th>
                                <th>Werktijd</th>
                                <th class="d-none d-sm-block">
                                    {{ environment.executorName }}
                                </th>
                            </tr>
                            @if (realisation?.planning?.planning_has_all) {
                                @for (planning of realisation.planning.planning_has_all; track planning) {
                                    @if (Utils.dateString(planning?.begindate) === dateString) {
                                        @if (planning?.driver_user?.name) {
                                            <tr>
                                                <td>
                                                    {{ planning?.driver_user?.name }}
                                                    <div class="d-sm-none">
                                                        <i>{{ planning?.entity?.name }}</i
                                                        ><br />
                                                        <b>{{ environment.executorName }}:</b>
                                                        {{ planning.performer?.name ?? '-' }}
                                                    </div>
                                                </td>
                                                <td class="d-none d-sm-block">
                                                    {{ planning?.entity?.name }}
                                                </td>
                                                <td class="time">
                                                    {{ planning?.begindate | date: 'HH:mm' }} -
                                                    {{ planning?.enddate | date: 'HH:mm' }}
                                                </td>
                                                <td class="d-none d-sm-block">
                                                    {{ planning.performer?.name ?? '-' }}
                                                </td>
                                            </tr>
                                        }
                                    }
                                }
                            }

                            @if (realisation?.planning?.user_planning) {
                                @for (userPlanning of realisation.planning.user_planning; track userPlanning) {
                                    @if (Utils.dateString(userPlanning?.begindate) === dateString) {
                                        @if (userPlanning?.user?.name) {
                                            <tr>
                                                <td>
                                                    {{ userPlanning?.user?.name }}
                                                </td>
                                                <td class="d-none d-sm-block"></td>
                                                <td class="time">
                                                    {{ userPlanning?.begindate | date: 'HH:mm' }} -
                                                    {{ userPlanning?.enddate | date: 'HH:mm' }}
                                                </td>
                                                <td class="d-none d-sm-block">
                                                    {{
                                                        realisation.planning.performer_user?.name ??
                                                            (
                                                                realisation?.project ||
                                                                realisation?.user_planning?.project
                                                            )?.performer?.name ??
                                                            '-'
                                                    }}
                                                    @if (realisation?.planning?.asphalt_performer_user) {
                                                        / {{ realisation?.planning?.asphalt_performer_user.name }}
                                                    }
                                                </td>
                                            </tr>
                                        }
                                    }
                                }
                            }
                        </table>
                    }
                </div>
            </div>
        }
    }
</div>
<div class="button-wrapper">
    <div class="container-xl">
        <div class="buttons">
            <button class="planning-button" (click)="back()" mat-raised-button color="primary">Terug</button>

            @if (date < maxDate && (Functionalities.Hours | hasFunctionality)) {
                <button
                    class="planning-button ms-2"
                    mat-raised-button
                    color="accent"
                    routerLink="/hours/{{ date | date: 'yyyy-MM-dd' }}">
                    Urenregistratie
                </button>
            }
        </div>
    </div>
</div>
